import { CheckboxGroup, Input, Label } from '@tlx/atlas';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';

export function SimplifiedPaymentSection({ disabled }: { disabled: boolean }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="atl-mt-24">
            <hr className={'tsk-mx-n32 atl-bg-grey-20 atl-mb-24'} />
            <CheckboxGroup className={'atl-flex atl-items-center atl-gap-8'}>
                <Input
                    id={'simplifiedPayment'}
                    name={'simplifiedPayment'}
                    type="toggle"
                    checked={open}
                    onChange={() => {
                        setOpen((prevState) => !prevState);
                    }}
                    data-testid="asset-edit-history-from-external"
                    disabled={disabled}
                />
                <Label htmlFor={'simplifiedPayment'} className={'atl-text-grey-120'}>
                    <FormattedMessage id={'text_simplified_salary_payment'} />
                </Label>
            </CheckboxGroup>
            <Label className={'atl-text-grey-80 atl-pt-16 atl-text-sm'}>
                <FormattedMessage id={'text_new_wage_transaction_light'} />
            </Label>
            {open && (
                <div className={'atl-flex atl-flex-col atl-gap-y-12 atl-mt-16'}>
                    <CheckboxGroup className={'atl-flex atl-items-center atl-gap-8'}>
                        <Input
                            type={'checkbox'}
                            data-testid={'simplified_fixed_or_hourly'}
                            defaultChecked={true}
                            name={'regularSalary'}
                            id={'regularSalary'}
                            disabled={disabled}
                        />
                        <Label htmlFor={'regularSalary'}>
                            <FormattedMessage id={'text_regular_salary_only'} />
                        </Label>
                    </CheckboxGroup>
                    <CheckboxGroup className={'atl-flex atl-items-center atl-gap-8'}>
                        <Input
                            type={'checkbox'}
                            data-testid={'simplified_travel_expenses'}
                            defaultChecked={true}
                            name={'travelReports'}
                            id={'travelReports'}
                            disabled={disabled}
                        />
                        <Label htmlFor={'travelReports'}>
                            <FormattedMessage id={'text_travel_reports'} />
                        </Label>
                    </CheckboxGroup>
                    <CheckboxGroup className={'atl-flex atl-items-center atl-gap-8'}>
                        <Input
                            type={'checkbox'}
                            data-testid={'simplified_open_posts'}
                            defaultChecked={true}
                            name={'openPosts'}
                            id={'openPosts'}
                            disabled={disabled}
                        />
                        <Label htmlFor={'openPosts'}>
                            <FormattedMessage id={'text_open_posts'} />
                        </Label>
                    </CheckboxGroup>
                    <CheckboxGroup className={'atl-flex atl-items-center atl-gap-8'}>
                        <Input
                            type={'checkbox'}
                            data-testid={'simplified_employee_expenses'}
                            defaultChecked={true}
                            name={'employeeExpenses'}
                            id={'employeeExpenses'}
                            disabled={disabled}
                        />
                        <Label htmlFor={'employeeExpenses'}>
                            <FormattedMessage id={'text_employee_expense'} />
                        </Label>
                    </CheckboxGroup>
                </div>
            )}
            <hr className={'tsk-mx-n32 atl-mt-24'} />
        </div>
    );
}
